import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default function VoucherEditorTableTR({ className, isDetails, ...props }) {
  return (
    <tr
      className={classNames(className, { 'voucher-table-form__details-row': isDetails })}
      {...props}
    />
  );
}

VoucherEditorTableTR.propTypes = {
  className: PropTypes.string,
  isDetails: PropTypes.bool,
};
